import {SourcesDispatcher} from '../core/dispatchers'
import {ISourcesDispatcher} from '../core/interfaces/dispatchers'

export class AppSourcesDispatcher extends SourcesDispatcher {}

export const appSourcesDispatcher = new AppSourcesDispatcher() as ISourcesDispatcher
